// Ported verbatim from the mobile app (PrecisionReactNative src/common/assets/images/equipment/eqDumbbellsSVG.tsx); generated — regenerate rather than edit.
import * as React from "react";

type Props = {
  fill: string;
  width?: number;
  height?: number;
};

function EqDumbbellsSVG(props: Props) {
  const {fill, width = 16, height = 16} = props;
  return (
    <svg width={width} height={height} viewBox="0 0 24 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 2C4.44772 2 4 2.44772 4 3V7V9V13C4 13.5523 4.44772 14 5 14C5.55228 14 6 13.5523 6 13V9V7V3C6 2.44772 5.55228 2 5 2ZM2 3V7H1H0V9H1H2V13C2 14.6569 3.34315 16 5 16C6.65685 16 8 14.6569 8 13V9H16V13C16 14.6569 17.3431 16 19 16C20.6569 16 22 14.6569 22 13V9H23H24V7H23H22V3C22 1.34315 20.6569 0 19 0C17.3431 0 16 1.34315 16 3V7H8V3C8 1.34315 6.65685 0 5 0C3.34315 0 2 1.34315 2 3ZM18 9V13C18 13.5523 18.4477 14 19 14C19.5523 14 20 13.5523 20 13V9V7V3C20 2.44771 19.5523 2 19 2C18.4477 2 18 2.44771 18 3V7V9Z"
        fill={fill}
      />
    </svg>
  );
}

export default EqDumbbellsSVG;
